import { useEffect, useState } from 'react';
// import { useSelector } from 'react-redux';

import LeafletNearestDrivers from '../../Components/LeafletNearestDrivers';
import { isEmpty } from '../../Utils/string';
import Spinner from '../../Components/Spinner';

const OrderDriverPickupMobile = () => {
    // const { dataMapLocations } = useSelector((state: any) => state.userReducer);

    const [coordinateDriver, setCoordinateDriver] = useState<[{ latitude: number; longitude: number }]>([{ latitude: 0, longitude: 0 }]);
    const [mergedDestinations, setMergedDestinations] = useState<Array<[]>>([]);

    const [dataOrderRide, setDataOrderRide] = useState<any[]>([]);
    const [driverData, setDriverData] = useState<any | null>(null);

    useEffect(() => {
        document.addEventListener('message', (event: any) => {
            const receivedData = JSON.parse(event.data);
            if (receivedData.type === 'ROUTE_PAYLOAD') {
                setDriverData(receivedData?.payload?.drivers);
                setDataOrderRide(receivedData?.payload?.dataOrderRide);
            }
        });
    }, []);

    // Update coordinateDriver when tracking data changes
    useEffect(() => {
        if (driverData) {
            setCoordinateDriver([{
                latitude: driverData?.latitude,
                longitude: driverData?.longitude
            }]);
        }
    }, [driverData]);


    // Update mergedDestinations when dataOrderRide or coordinateDriver changes
    useEffect(() => {
        if (dataOrderRide?.[0]?.destination && coordinateDriver.length > 0) {
            setMergedDestinations([
                ...dataOrderRide?.[0]?.destination,
                ...coordinateDriver
            ]);
        }
    }, [dataOrderRide, coordinateDriver,]);

    // Cek jika semua data sudah siap sebelum render peta
    const isDataReady = (
        dataOrderRide?.[0]?.pickup_point &&
        mergedDestinations.length > 0
    );

    return (
        <>
            {isEmpty(dataOrderRide) ? (

                <div className="h-screen flex justify-center items-center bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 relative overflow-hidden">
                    {/* Background animated elements */}
                    <div className="absolute inset-0 overflow-hidden">
                        <div className="absolute -top-40 -right-40 w-80 h-80 bg-gradient-to-r from-blue-400/20 to-purple-400/20 rounded-full animate-pulse"></div>
                        <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-gradient-to-r from-indigo-400/20 to-blue-400/20 rounded-full animate-pulse delay-1000"></div>
                        <div className="absolute top-1/3 left-1/4 w-32 h-32 bg-gradient-to-r from-purple-400/10 to-pink-400/10 rounded-full animate-bounce delay-500"></div>
                    </div>

                    {/* Main content */}
                    <div className="relative z-10 text-center space-y-8">
                        {/* Animated loading icon */}
                        {/* <div className="relative">
                            <div className="w-20 h-20 mx-auto">
                                <div className="absolute inset-0 border-4 border-blue-200 rounded-full"></div>
                                <div className="absolute inset-0 border-4 border-transparent border-t-blue-600 rounded-full animate-spin"></div>
                                <div className="absolute inset-2 border-4 border-transparent border-t-purple-500 rounded-full animate-spin animate-reverse delay-150"></div>
                            </div>
                        </div> */}

                        {/* Main text with gradient */}
                        <div className="space-y-4">
                            {/* <h1 className="text-3xl font-bold bg-gradient-to-r from-blue-600 via-purple-600 to-indigo-600 bg-clip-text text-transparent animate-pulse">
                                Sedang Menunggu Orderan
                            </h1> */}

                            {/* Subtitle */}
                            <p className="text-gray-600 text-lg p-2 font-medium opacity-80">
                                Kami sedang mencari pesanan terbaik untuk Anda
                            </p>

                            {/* Animated dots */}
                            <div className="flex justify-center space-x-2 mt-6">
                                <div className="w-3 h-3 bg-blue-500 rounded-full animate-bounce"></div>
                                <div className="w-3 h-3 bg-purple-500 rounded-full animate-bounce delay-150"></div>
                                <div className="w-3 h-3 bg-indigo-500 rounded-full animate-bounce delay-300"></div>
                            </div>
                        </div>

                        {/* Progress bar */}
                        <div className="w-64 h-2 bg-gray-200 rounded-full mx-auto overflow-hidden">
                            <div className="h-full bg-gradient-to-r from-blue-500 to-purple-500 rounded-full animate-pulse"></div>
                        </div>

                        {/* Status indicators */}
                        {/* <div className="flex justify-center space-x-8 mt-8 text-sm text-gray-500">
                            <div className="flex items-center space-x-2">
                                <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                                <span>Sistem Aktif</span>
                            </div>
                            <div className="flex items-center space-x-2">
                                <div className="w-2 h-2 bg-blue-500 rounded-full animate-pulse delay-300"></div>
                                <span>Mencari Orderan</span>
                            </div>
                        </div> */}
                    </div>

                    {/* Floating particles effect */}
                    <div className="absolute inset-0 pointer-events-none">
                        <div className="absolute top-1/4 left-1/3 w-1 h-1 bg-blue-400 rounded-full opacity-60 animate-ping delay-1000"></div>
                        <div className="absolute top-3/4 right-1/3 w-1 h-1 bg-purple-400 rounded-full opacity-60 animate-ping delay-2000"></div>
                        <div className="absolute top-1/2 left-1/5 w-1 h-1 bg-indigo-400 rounded-full opacity-60 animate-ping delay-500"></div>
                        <div className="absolute bottom-1/4 right-1/4 w-1 h-1 bg-pink-400 rounded-full opacity-60 animate-ping delay-1500"></div>
                    </div>

                    {/* Custom CSS for reverse animation */}

                </div>
            ) : (
                <>
                    {isEmpty(driverData) ? (
                        <Spinner />
                    ) : (
                        <>
                            {isDataReady ? (
                                <>
                                    <LeafletNearestDrivers
                                        isShowHandleDriverClick={false}
                                        customer={dataOrderRide?.[0]?.pickup_point}
                                        drivers={mergedDestinations}
                                        // locationMaps={dataMapLocations?.data}
                                        isReverseGeocode={false}
                                        isPickupPoint={true}
                                        zoom={12}
                                        height="100vh"
                                    />
                                </>
                            ) : (
                                <Spinner />
                            )}
                        </>
                    )}
                </>
            )}
        </>
    );
}

<style>{`
    @keyframes reverse-spin {
      from {
        transform: rotate(360deg);
      }
      to {
        transform: rotate(0deg);
      }
    }
    .animate-reverse {
      animation: reverse-spin 1s linear infinite;
    }
  `}</style>

export default OrderDriverPickupMobile;
